import './ComponentModal.scss';

export { default } from './ComponentModal';
